export default {
  online: 'online',
  migration: 'migration',
  app: 'mobile app',
};
